import type { VirtualClinicAnalysisOperatingNumberCalculation } from './calculation';
import { VirtualClinicAnalysisOperatingNumberSingleVirtualClinicCalculation } from './single-virtual-clinic-calculation';
import { VirtualClinicAnalysisOperatingNumberBenchmarkingCalculation } from './benchmarking-calculation';
import { VirtualClinicAnalysisOperatingNumberTermFactory } from '../term';
import { VirtualClinicAnalysisClinicsFilter } from '../filter/clinics-filter';
import type { FilterRegistrationToken } from '@bindoc-projects/filter-condition-domain-lib';

export class VirtualClinicAnalysisOperatingNumberCalculationFactory {
  public static async fromObject(
    obj: {
      type: 'benchmarking' | 'single-virtual-clinic';
      term: any;
      virtualClinicId: string;
      clinicsFilter?: any;
    },
    registeredFilter: FilterRegistrationToken[],
  ): Promise<VirtualClinicAnalysisOperatingNumberCalculation> {
    switch (obj.type) {
      case 'single-virtual-clinic': {
        return VirtualClinicAnalysisOperatingNumberTermFactory.fromObject(
          obj.term,
          registeredFilter,
        ).then(
          (term) =>
            new VirtualClinicAnalysisOperatingNumberSingleVirtualClinicCalculation(
              term,
              obj.virtualClinicId,
            ),
        );
      }
      case 'benchmarking': {
        return Promise.all([
          VirtualClinicAnalysisOperatingNumberTermFactory.fromObject(
            obj.term,
            registeredFilter,
          ),
          obj.clinicsFilter
            ? VirtualClinicAnalysisClinicsFilter.fromObject(
                obj.clinicsFilter,
                registeredFilter,
              )
            : Promise.resolve(null),
        ]).then((data) => {
          return new VirtualClinicAnalysisOperatingNumberBenchmarkingCalculation(
            data[0],
            data[1],
          );
        });
      }
      default:
        throw new Error(`Unknown calculation type: ${obj.type}`);
    }
  }
}
